import { useQuotationTask } from '@/hooks/api/1480_quotation_task';
import { TeamMemberLogic } from '@/hooks/api/models/logics';
import { toastError } from '@/lib/toast';
import { useCurrentQuotationTask } from '@/providers/QuotationTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

type Props = { children?: React.ReactNode };

export const RequireQuotationTask = ({ children }: Props) => {
  const location = useLocation();
  const { meTeamMember } = useCurrentTeamMember();
  const { identifier, team_id, sales_order_id, quotation_task_id } = useParams();
  const { data, status } = useQuotationTask({
    identifier: identifier!,
    team_id: Number(team_id!),
    sales_order_id: Number(sales_order_id!),
    id: Number(quotation_task_id!),
  });
  const { quotationTask, setQuotationTask } = useCurrentQuotationTask();

  useEffect(() => {
    if (data) {
      setQuotationTask((_) => data);
    }
  }, [data]);

  if (status == 'error') {
    toastError('アクセス出来ませんでした。');
    return <Navigate replace to={`/w/${identifier}`} />;
  }

  // backoffice権限のみの場合
  if (meTeamMember && TeamMemberLogic.hasBackofficeOnlyRole(meTeamMember!)) {
    // urlがプロジェクト配下のurlの場合は、backoffice配下のurlに遷移
    if (location.pathname.startsWith(`/w/${identifier}/teams/`)) {
      return <Navigate replace to={`/w/${identifier}/backoffice/teams/${team_id}/sales_orders/${sales_order_id}/quotation_tasks/${quotation_task_id}`} />;
    }
  }

  if (quotationTask) {
    return <>{children}</>;
  }

  return <></>;
};
